module.exports = __webpack_public_path__ + "static/media/sidd_logo2.cacdd036.png";